// This should only be used by getStore() and setStore.
// Don't export in store/index.js
const storeManager = {
  store: undefined
};

export default storeManager;